import { TENANT_ID } from "./api-factory"
const POST_HEADER = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    
}



const TENANT_POST_HEADER = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Tenant-ID':TENANT_ID
}
const MULTIPART_TENANT_POST_HEADER = {
    'Accept': 'application/json',
    'Content-Type': 'multipart/form-data',
    'X-Tenant-ID':TENANT_ID
}
const TENANT_BRE_POST_HEADER = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Tenant-ID':TENANT_ID
}

const GET_HEADER = {
    
}
const TENANT_HEADER = {
    headers:{
        'X-Tenant-ID':TENANT_ID
    }
}


const CUSTOM_NEW_HEADER = {
    headers: {
       "Content-Type": "application/json",
    "x-api-key": "business-loan-test-key-001",
    "x-api-secret": "business-loan-test-secret-001",
    }
}
const CUSTOM_NEW_MULTIPART_HEADER = {
    headers: {
        // 'Access-Control-Allow-Origin': '*',
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data',
        'x-api-key': 'business-loan-test-key-001',
        'x-api-secret': 'business-loan-test-secret-001',
    }
}

const CUSTOM_NEW_MULTIPART_HEADER_WITHOUT_KEY = {
    headers: {
        // 'Access-Control-Allow-Origin': '*',
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data',
      
    }
}

export {
    TENANT_POST_HEADER,
    POST_HEADER,
    GET_HEADER,
    TENANT_HEADER,
    TENANT_BRE_POST_HEADER,
    MULTIPART_TENANT_POST_HEADER,
    CUSTOM_NEW_HEADER,
    CUSTOM_NEW_MULTIPART_HEADER,
    CUSTOM_NEW_MULTIPART_HEADER_WITHOUT_KEY

}